/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default class Brand {
	constructor() {
		this.initEvents();
	}

	initEvents() {
		const hash = window.location.hash.substring(1).split("-");

		if (hash[0] === "products") {
			$('.product-wrapper').show();
			$('.js-toggle-content').toggleClass('is-open');
			$('.banner__text').text($('.js-toggle-content').attr('data-show'));
			window.location.hash = '#products';

			if (typeof hash[1] !== "undefined") {
				hash[1] = hash[1].replace('%25+', '-');

				if ($(`.product-types-list__item[data-filter="${hash[1]}"]`).length) {
					$('.product-types-list__item').removeClass('is-active');
					$('.product-item').addClass('is-hidden');
					$(`.product-types-list__item[data-filter="${hash[1]}"]`).addClass('is-active');
					$(`.product-item[data-filter="${hash[1]}"]`).removeClass('is-hidden');

					const select = $('select[name="product-types"]');
					const option = $(`select[name="product-types"] option[value="${hash[1]}"]`);
					$('.select__option').removeClass('is-selected is-active');
					select.parent().find(`.select__option[data-value="${hash[1]}"]`).addClass('is-selected is-active');
					$('.select__placeholder span').html(option.text());
				}
			}
		}

		//add class index class
		$('.product-types-list__item').each(function () {
			return $(`.product-item[data-filter="${$(this).attr('data-filter')}"]`).each(function (index, value) {
				if (((index + 1) % 4) === 0) {
					$(this).addClass('nth-4');
				}
				if (((index + 1) % 3) === 0) {
					$(this).addClass('nth-3');
				}
				if (((index + 1) % 2) === 0) {
					return $(this).addClass('nth-2');
				}
			});
		});

		//click event on filter item in list
		$('.product-types-list__item').on('click', e => {
			e.preventDefault();
			const filter = $(e.target).attr('data-filter');
			return this.filter_products(filter);
		});

		//click event on filter item in dropdown (mobile)
		return $('select[name="product-types"]').on('change', e => {
			const filter = $(e.target).val();
			return this.filter_products(filter);
		});
	}

	filter_products(filter) {
		//logic for active element in dropdown (mobile)
		$('.product-types .select .select__option').removeClass('is-selected is-active');
		const text = $(`.product-types .select .select__option[data-value="${filter}"]`).addClass('is-selected is-active').text();
		$('.product-types .select .select__placeholder span').text(text);

		//logic for active element in filter list
		$('.product-types-list__item').removeClass('is-active');
		$(`.product-types-list__item[data-filter="${filter}"]`).addClass('is-active');

		//show and hide correct products based on filter
		$('.product-item ').addClass('is-hidden');
		return $(`.product-item[data-filter="${filter}"]`).removeClass('is-hidden');
	}
}
